import { CopyIcon } from '@blueprinthq/joy'
import {
  Box,
  Code,
  Divider,
  Flex,
  IconButton,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack
} from '@chakra-ui/react'
import { useSessionManagement } from '@context'
import { useExperienceManager } from '@hooks'
import { copyToClipboard } from '@utilities'
import React from 'react'
import { useSessionControllerDebug } from '~/clinician-api'

interface SessionDebuggerModalProps {
  isOpen: boolean
  onClose: () => void
  selectedProgressNoteId: string | undefined
}

const CopyButton = ({ text }: { text: string }) => {
  return (
    <IconButton
      m="0px"
      background={'white'}
      _hover={{
        bg: '#E4E5E6'
      }}
      size="xs"
      aria-label="copy"
      onClick={() => {
        copyToClipboard(text)
      }}
      border="none"
      variant="outline"
      style={{
        borderRadius: '4px'
      }}
    >
      <CopyIcon size="sm" />
    </IconButton>
  )
}

export const SessionDebuggerModal: React.FC<SessionDebuggerModalProps> = ({
  isOpen,
  onClose,
  selectedProgressNoteId
}) => {
  const { isSuperAdmin } = useExperienceManager()
  const { sessionId } = useSessionManagement()

  const { data: sessionDebug } = useSessionControllerDebug(sessionId, {
    query: {
      enabled: !!sessionId && isSuperAdmin
    }
  })

  const selectedProgressNote = sessionDebug?.progressNotes?.find(
    (note: any) => note.id === selectedProgressNoteId
  )

  if (!selectedProgressNoteId) {
    return null
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Session Debugger</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack align="flex-start" spacing={4}>
            <Box>
              <Text fontWeight="bold" mb={2}>
                Progress Note ID
              </Text>
              <Flex alignItems="center">
                <Code mr="xsmall">{selectedProgressNoteId}</Code>
                <CopyButton text={selectedProgressNoteId} />
              </Flex>
            </Box>
            <Divider />

            <Box>
              {selectedProgressNote?.vellumExecutionUrl ? (
                <Link
                  href={selectedProgressNote?.vellumExecutionUrl as any}
                  target="_blank"
                  color="blue.500"
                  fontSize="sm"
                  fontWeight="bold"
                  mb={2}
                >
                  Vellum Execution Link
                </Link>
              ) : (
                <Text>No vellum execution url found</Text>
              )}
            </Box>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
